import { GetValidationViolationsResponse } from './src/service-plugins-types.js';
import { GetValidationViolationsEnvelope } from './src/interfaces-ecommerce-v1-validations-provider.public.js';

export * from './src/service-plugins-types';
export { GetValidationViolationsEnvelope };

/**
 * This method retrieves validation violations from your app.
 *
 * Wix calls this method when certain actions are performed on a visitor's cart and checkout. For example, when an item is added to the cart, or when a coupon is added to a checkout.
 * This method validates a visitor's cart and checkout, and returns any validation violations (using the structure provided by Wix eCommerce). Site visitors can see the validation violations in their cart and checkout pages. If there aren't any validation violations, the method returns an object containing an empty list.
 *
 * > __Notes:__
 * > + Do not call the Estimate Cart Totals, Estimate Current Cart Totals or Get Checkout methods from your implementation code for Get Validation Violations. Doing so will result in an error.
 * > + By default, this method only retrieves validation violations from a visitor's checkout. If you want to also retrieve validation violations from a visitor's cart, set the `validateInCart` parameter to `true` in the Ecom Validations Integration's config file.
 */
export declare function getValidationViolations(
  payload: GetValidationViolationsEnvelope
): GetValidationViolationsResponse | Promise<GetValidationViolationsResponse>;
